import { useEffect, useState } from 'react';
import { HARD_PORTAL_COST } from './portalRoutes';
import './PortalUnlockSequence.css';

export const PORTAL_UNLOCK_MS = 2250;

const PortalUnlockSequence = ({ shards, reduceMotion = false }) => {
  const [spent, setSpent] = useState(0);
  useEffect(() => {
    if (reduceMotion) {
      setSpent(HARD_PORTAL_COST);
      return undefined;
    }
    const timers = Array.from({ length: HARD_PORTAL_COST }, (_, index) =>
      setTimeout(() => setSpent(index + 1), 500 + index * 320)
    );
    return () => timers.forEach(clearTimeout);
  }, [reduceMotion]);
  return (
    <div
      className={`coreboundPortalPayment ${
        spent === HARD_PORTAL_COST ? 'is-open' : ''
      } ${reduceMotion ? 'is-reduced' : ''}`}
      role="status"
      aria-live="polite"
    >
      <span className="coreboundPanelKicker">
        HARD ROUTE / {HARD_PORTAL_COST} SHARDS
      </span>
      <div className="coreboundPortalPaymentArt" aria-hidden="true">
        <div className="coreboundPortalPaymentGate">
          <i />
          <i />
          <b>{spent === HARD_PORTAL_COST ? 'OPEN' : 'LOCKED'}</b>
        </div>
        {Array.from({ length: HARD_PORTAL_COST }, (_, index) => (
          <svg
            key={index}
            className="coreboundPortalPaymentShard"
            viewBox="0 0 40 50"
            style={{ '--shard-index': index }}
          >
            <path d="M20 2 37 17 26 47 6 34 3 15Z" />
            <path d="m20 2 6 45-5-30L3 15m18 2 16 0" />
          </svg>
        ))}
      </div>
      <strong>
        {spent === HARD_PORTAL_COST ? 'PORTAL UNLOCKED' : 'POWERING THE PORTAL'}
      </strong>
      <span className="coreboundPortalPaymentWallet">
        {shards - spent} shards remaining
      </span>
      <small>
        {spent === HARD_PORTAL_COST
          ? 'Three shards committed. Entering the harder route…'
          : 'Your shards are opening the gate.'}
      </small>
    </div>
  );
};
export default PortalUnlockSequence;
